import { makeStyles } from "@material-ui/styles";

const gameContainerStyles = makeStyles(() => ({
	header: {
		height: 120
	},
	container: {
		height: "calc(100% - 120px)"
	},
	scoreBox: {
		"& .MuiGrid-item span, p": { color: "#FFFFFF" }
	}
}));

export default gameContainerStyles;
